let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gA3cJ")).then(() => parcelRequire('5tfXX'));